import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";
import { ExternalLoggingConstants } from "../ExternalLoggingConstants";

export class PageIntegrationErrorFactory extends BasicLogObjectFactory {

    private static PAGE_INTEGRATION_ERROR: number = 101;

    public static CACHE_BREAKER_ELEMENT_MISSING: number = 101001;
    public static GAME_ELEMENT_MISSING: number = 101002;

    private static PARAM_ERROR_MESSAGE: string = "errorMessage";

    private _errorMessage: string;

    constructor(subErrorId: number, errorMessage: string) {
        super();
        this._subErrorId = subErrorId;
        this._errorMessage = errorMessage;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, PageIntegrationErrorFactory.PAGE_INTEGRATION_ERROR.toString());
        lo.logData.set(PageIntegrationErrorFactory.PARAM_ERROR_MESSAGE, this._errorMessage);

        return lo;
    }
}
